import queryString from 'query-string';

import httpApiApplication from '@/app/http/httpApiApplication';
import { buildParams } from '@/utils/params';

import { type IdValue } from '../../TaxStatement/FormVersion/types';
import {
  type PaymentDeclaration,
  type PaymentDeclarationContent,
  type PaymentFileUploadResponse,
  type PaymentSummary,
  type ReconciliationOfPaymentRequest,
  type TaxpayerPayment
} from '../models/Payment';

export const BaseUrPaymentDeclaration = '/payments/declaration';

export const BaseUrPayment = '/payments';

const baseUrl = '/taxpayers';

type Translate = (key: string) => string;

export const paymentService = {
  createPaymentMatch: async (request: ReconciliationOfPaymentRequest): Promise<void> => {
    return httpApiApplication.post(`${BaseUrPaymentDeclaration}/reconcile`, request);
  },
  createPaymentDeclaration: async (payment: PaymentDeclarationContent): Promise<IdValue> => {
    return httpApiApplication.post(BaseUrPaymentDeclaration, payment);
  },
  getPaymentDeclaration: async (id: string): Promise<PaymentDeclaration> => {
    return httpApiApplication.get(BaseUrPaymentDeclaration + '/' + id);
  },
  getPayment: async (id: string): Promise<PaymentSummary> => {
    return httpApiApplication.get('/payments' + '/' + id);
  },
  rejectPayment: async (
    id: string,
    request: { reason: string }
  ): Promise<{ taxReturnPaymentId: string }> => {
    return httpApiApplication.put(`${BaseUrPaymentDeclaration}/${id}/reject`, request);
  },
  getPaymentsFromTaxpayer: async (
    tin: string,
    params: {
      taxCode?: number;
      dateFrom?: Date;
      dateTo?: Date;
    }
  ) => {
    const newParams = buildParams(params);
    const queryParams = newParams ? `?${queryString.stringify(newParams)}` : '';

    return httpApiApplication.get<Array<TaxpayerPayment>>(
      `${baseUrl}/payments/${tin}${queryParams}`
    );
  },
  uploadPayments: async (request: FormData): Promise<PaymentFileUploadResponse> => {
    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    };
    return httpApiApplication.postCfg('taxreturnpayments/received', request, config);
  },
  createPaymentFileUploadRequest: (attachment: File, taxCollectorId: string): FormData => {
    const formData = new FormData();
    formData.append('attachment', attachment);
    formData.append('TaxCollectorId', taxCollectorId);

    return formData;
  },
  paymentFileUploadSuccessPath: ({ id }: PaymentFileUploadResponse): string =>
    `/payments/bank/upload/${id}/success`
};
